module.exports = __webpack_public_path__ + "img/bringo-transport-gratuit.9c7e08b9.png";